import type { PlainDate } from "@sa-nu/shared-utils/date";

const INITIAL_VISIBLE_MONTH_OFFSET = 1;

/**
 * 日程未選択でカレンダーを開いたときに最初に見せる日。滞在期間フィルタと部屋タイプ予約
 * カレンダーで同じ基準にするため共有する。
 */
export function getInitialVisibleDate(today: PlainDate): PlainDate {
  return today.add({ months: INITIAL_VISIBLE_MONTH_OFFSET });
}
